import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addFilterGroup({ dispatch, commit }, brand) {
    try {
      const { data } = await request.post('filterGroups', brand);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
